import {create} from 'zustand';
import {persist, devtools} from 'zustand/middleware';
import {immer} from 'zustand/middleware/immer';

export interface GuestCardData {
  guest_name: string;
  room_number: string;
}

interface GuestCardState {
  guestCardData: GuestCardData | null;
}

interface GuestCardActions {
  setGuestName: (guestName: string) => void;
  setRoomNumber: (roomNumber: string) => void;
  setGuestCardData: (data: GuestCardData) => void;
  clearGuestCardData: () => void;
}

const initialState: GuestCardState = {
  guestCardData: null,
};

export const useGuestCardStore = create<GuestCardState & GuestCardActions>()(
  devtools(
    persist(
      immer(set => ({
        ...initialState,

        setGuestName: (guestName: string) =>
          set(state => {
            state.guestCardData = {
              room_number: state.guestCardData?.room_number ?? '',
              guest_name: guestName,
            };
          }),

        setRoomNumber: (roomNumber: string) =>
          set(state => {
            state.guestCardData = {
              guest_name: state.guestCardData?.guest_name ?? '',
              room_number: roomNumber,
            };
          }),

        setGuestCardData: (data: GuestCardData) =>
          set(state => {
            state.guestCardData = data;
          }),

        clearGuestCardData: () =>
          set(state => {
            state.guestCardData = null;
          }),
      })),
      {
        name: 'chekin-guest-card-store',
      },
    ),
  ),
);
